export default {
    modal_move: {
        status: 'Mover Status - {{title}}',
        task: 'Mover Tarefa - {{title}}',
        all_tasks: 'Mover Todas as Tarefas com Status - {{title}}'
    },
    error: {
        move_tasks: 'Não foi possível mover as seguintes tarefas',
        archive_tasks: 'Não foi possível arquivar as seguintes tarefas',
    },
    alert: {
        archive_all_tasks_title: 'Você deseja arquivar todas as tarefas com status {{status}}?',
        archive_all_tasks_text: 'Após arquivar as tarefas não será mais possível atualizá-las.',
    },
}
